<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item, externalItem } from '../components/Item.vue'

  import Jewel05 from './Jewel05.vue'
  import Promo2019Events from './Promo2019_Events.vue'
  import Promo2019Pact from './Promo2019_Pact.vue'

  /** @typedef {import('../components/Item.vue').ItemInfo} ItemInfo */
  /** @type {ItemInfo[]} */ const itemsJ05 = Jewel05.data().items
  /** @type {ItemInfo[]} */ const itemsPromo2019Events = Promo2019Events.data().items
  /** @type {ItemInfo[]} */ const itemsPromo2019Pact = Promo2019Pact.data().items


  /** @type {ItemInfo[]} ジュエル5弾「ニコチケ二択目」アイテム情報群 */
  const Nico2Items = _.where(itemsJ05, { collection: 'ニコチケ二択目' })

  /**
   * ジュエル5弾「ニコチケ二択目」のアイテム情報を得る
   * @param {string} id - アイテム ID
   * @return {ItemInfo}
   * @see {externalItem}
   */
  function nico2Item (id = '') {
    return externalItem(Nico2Items, id)
  }

  /**
   * 「ニコチケ二択目」用のスペーサー項目を作成
   * @param {string} rare - レアリティ
   * @return {ItemInfo}
   * @see {item}
   */
  function nico2Spacer (rare = '') {
    return item({ collection: 'ニコチケ二択目', rare })
  }


  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2021-05-22',
        major: [
          'えもコレクション',
          'ダイヤモンドコレクション',
          '共通',
        ],
        excepts: [
        ],
        items: [

          // [NOTE] JR10
          // ================================================================================

          item({
            collection  : 'えもコレクション',
            id          : 'JR10-04',
            rare        : 'JR',
            name        : 'ゆうきのピンクジュエルドレス',
            imgUrl      : '/images/items/JR10-04.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 1500,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'JR10-05',
            rare        : 'JR',
            name        : 'ゆうきのピンクジュエルシューズ',
            imgUrl      : '/images/items/JR10-05.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'JR10-06',
            rare        : 'JR',
            name        : 'ゆうきのピンクジュエルヘアアクセ',
            imgUrl      : '/images/items/JR10-06.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'えもコレクション',
            id          : 'JR10-01',
            rare        : 'JR',
            name        : 'ゆうきのイエロージュエルドレス',
            imgUrl      : '/images/items/JR10-01.png',
            kind        : 'ワンピース',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 1500,
            numOwned    : { kira: 1, usual: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'JR10-02',
            rare        : 'JR',
            name        : 'ゆうきのイエロージュエルシューズ',
            imgUrl      : '/images/items/JR10-02.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 1, usual: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'JR10-03',
            rare        : 'JR',
            name        : 'ゆうきのイエロージュエルヘアアクセ',
            imgUrl      : '/images/items/JR10-03.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 1, usual: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'えもコレクション',
            id          : 'JR10-07',
            rare        : 'JR',
            name        : 'ゆうきのブルージュエルドレス',
            imgUrl      : '/images/items/JR10-07.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 1500,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'JR10-08',
            rare        : 'JR',
            name        : 'ゆうきのブルージュエルシューズ',
            imgUrl      : '/images/items/JR10-08.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'JR10-09',
            rare        : 'JR',
            name        : 'ゆうきのブルージュエルヘアアクセ',
            imgUrl      : '/images/items/JR10-09.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'えもコレクション',
            id          : 'JR10-10',
            rare        : 'JR',
            name        : 'ゆうきのゴールドジュエルドレス',
            imgUrl      : '//via.placeholder.com/100/ffcc66/666/?text=JR10-10',
            kind        : 'ワンピース',
            color       : '金',
            brand       : 'GY',
            type        : 'PO',
            point       : 1500,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'JR10-11',
            rare        : 'JR',
            name        : 'ゆうきのゴールドジュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/ffcc66/666/?text=JR10-11',
            kind        : 'シューズ',
            color       : '金',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'JR10-12',
            rare        : 'JR',
            name        : 'ゆうきのゴールドジュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/ffcc66/666/?text=JR10-12',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'えもコレクション',
            id          : 'JR10-13',
            rare        : 'JR',
            name        : 'ゆうきのブラックジュエルドレス',
            imgUrl      : '//via.placeholder.com/100/333/fff/?text=JR10-13',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : 'GY',
            type        : 'PO',
            point       : 1500,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'JR10-14',
            rare        : 'JR',
            name        : 'ゆうきのブラックジュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/333/fff/?text=JR10-14',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'JR10-15',
            rare        : 'JR',
            name        : 'ゆうきのブラックジュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/333/fff/?text=JR10-15',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'えもコレクション',
            id          : 'JR10-16',
            rare        : 'JR',
            name        : 'ゆうきのレッドジュエルドレス',
            imgUrl      : '/images/items/JR10-16.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 1500,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'JR10-17',
            rare        : 'JR',
            name        : 'ゆうきのレッドジュエルシューズ',
            imgUrl      : '/images/items/JR10-17.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'JR10-18',
            rare        : 'JR',
            name        : 'ゆうきのレッドジュエルヘアアクセ',
            imgUrl      : '/images/items/JR10-18.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'えもコレクション',
            id          : 'JR10-19',
            rare        : 'JR',
            name        : 'ゆうきのグリーンジュエルドレス',
            imgUrl      : '//via.placeholder.com/100/00770/fff/?text=JR10-19',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 1500,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'JR10-20',
            rare        : 'JR',
            name        : 'ゆうきのグリーンジュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/00770/fff/?text=JR10-20',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'JR10-21',
            rare        : 'JR',
            name        : 'ゆうきのグリーンジュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/00770/fff/?text=JR10-21',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'えもコレクション',
            id          : 'JR10-22',
            rare        : 'JR',
            name        : 'ゆうきのパープルジュエルドレス',
            imgUrl      : '/images/items/JR10-22.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 1500,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'JR10-23',
            rare        : 'JR',
            name        : 'ゆうきのパープルジュエルシューズ',
            imgUrl      : '/images/items/JR10-23.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'JR10-24',
            rare        : 'JR',
            name        : 'ゆうきのパープルジュエルヘアアクセ',
            imgUrl      : '/images/items/JR10-24.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'えもコレクション',
            id          : 'JR10-25',
            rare        : 'JR',
            name        : 'ゆうきのホワイトジュエルドレス',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR10-25',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 1500,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'JR10-26',
            rare        : 'JR',
            name        : 'ゆうきのホワイトジュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR10-26',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'JR10-27',
            rare        : 'JR',
            name        : 'ゆうきのホワイトジュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR10-27',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'えもコレクション',
            id          : 'JR10-28',
            rare        : 'JR',
            name        : 'ゆうきのレインボージュエルドレス',
            imgUrl      : '/images/items/JR10-28.png',
            kind        : 'ワンピース',
            color       : '虹',
            brand       : 'GY',
            type        : 'PO',
            point       : 1500,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'JR10-29',
            rare        : 'JR',
            name        : 'ゆうきのレインボージュエルシューズ',
            imgUrl      : '/images/items/JR10-29.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'JR10-30',
            rare        : 'JR',
            name        : 'ゆうきのレインボージュエルヘアアクセ',
            imgUrl      : '/images/items/JR10-30.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            rare        : 'JR',
          }),


          // [NOTE] RR
          // ================================================================================

          item({
            collection  : 'えもコレクション',
            id          : 'RR6-01',
            rare        : 'RR',
            name        : 'レインボーにんぎょひめトップス',
            imgUrl      : '/images/items/RR6-01.png',
            kind        : 'トップス',
            color       : '虹',
            brand       : 'PM',
            type        : 'PR',
            point       : 1000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'RR6-02',
            rare        : 'RR',
            name        : 'レインボーにんぎょひめスカート',
            imgUrl      : '/images/items/RR6-02.png',
            kind        : 'ボトムス',
            color       : '虹',
            brand       : 'PM',
            type        : 'PR',
            point       : 1000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'RR6-03',
            rare        : 'RR',
            name        : 'レインボーにんぎょひめシューズ',
            imgUrl      : '/images/items/RR6-03.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'PM',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'RR6-04',
            rare        : 'RR',
            name        : 'レインボーにんぎょひめヘアアクセ',
            imgUrl      : '/images/items/RR6-04.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'PM',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'えもコレクション',
            id          : 'RR6-05',
            rare        : 'RR',
            name        : 'レインボーメルティックスターワンピ',
            imgUrl      : '/images/items/RR6-05.png',
            kind        : 'ワンピース',
            color       : '虹',
            brand       : 'DW',
            type        : 'LO',
            point       : 2000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'RR6-06',
            rare        : 'RR',
            name        : 'レインボーメルティックスターシューズ',
            imgUrl      : '/images/items/RR6-06.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'DW',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'RR6-07',
            rare        : 'RR',
            name        : 'レインボーメルティックスターヘアアクセ',
            imgUrl      : '/images/items/RR6-07.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'DW',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            rare        : 'RR',
          }),


          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'RR6-08',
            rare        : 'RR',
            name        : 'レインボーホロスコープワンピ',
            imgUrl      : '/images/items/RR6-08.png',
            kind        : 'ワンピース',
            color       : '虹',
            brand       : 'MR',
            type        : 'PO',
            point       : 2000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'RR6-09',
            rare        : 'RR',
            name        : 'レインボーホロスコープシューズ',
            imgUrl      : '/images/items/RR6-09.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'MR',
            type        : 'PO',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'RR6-10',
            rare        : 'RR',
            name        : 'レインボーホロスコープヘアアクセ',
            imgUrl      : '/images/items/RR6-10.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'MR',
            type        : 'PO',
            point       : 950,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            rare        : 'RR',
          }),


          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'RR6-11',
            rare        : 'RR',
            name        : 'レインボーピュアプリンセスワンピ',
            imgUrl      : '/images/items/RR6-11.png',
            kind        : 'ワンピース',
            color       : '虹',
            brand       : 'SH',
            type        : 'LO',
            point       : 2000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'RR6-12',
            rare        : 'RR',
            name        : 'レインボーピュアプリンセスシューズ',
            imgUrl      : '/images/items/RR6-12.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'SH',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'RR6-13',
            rare        : 'RR',
            name        : 'レインボーピュアプリンセスヘアアクセ',
            imgUrl      : '/images/items/RR6-13.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'SH',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            rare        : 'RR',
          }),


          // [NOTE] HR
          // ================================================================================

          item({
            collection  : 'えもコレクション',
            id          : 'J6-01',
            rare        : 'HR',
            name        : 'にんぎょひめトップス',
            imgUrl      : '/images/items/J6-01.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 1100,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-02',
            rare        : 'HR',
            name        : 'にんぎょひめスカート',
            imgUrl      : '/images/items/J6-02.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 1050,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-03',
            rare        : 'HR',
            name        : 'にんぎょひめシューズ',
            imgUrl      : '/images/items/J6-03.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'PM',
            type        : 'PR',
            point       : 950,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-04',
            rare        : 'HR',
            name        : 'にんぎょひめヘアアクセ',
            imgUrl      : '/images/items/J6-04.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 950,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),



          item({
            collection  : 'えもコレクション',
            id          : 'J6-05',
            rare        : 'HR',
            name        : 'ホロスコープみずがめざワンピ',
            imgUrl      : '/images/items/J6-05.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'MR',
            type        : 'PO',
            point       : 2000,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-06',
            rare        : 'HR',
            name        : 'ホロスコープみずがめざシューズ',
            imgUrl      : '/images/items/J6-06.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'MR',
            type        : 'PO',
            point       : 950,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-07',
            rare        : 'HR',
            name        : 'ホロスコープみずがめざヘアアクセ',
            imgUrl      : '/images/items/J6-07.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'MR',
            type        : 'PO',
            point       : 950,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            rare        : 'HR',
          }),


          item({
            collection  : 'えもコレクション',
            id          : 'J6-08',
            rare        : 'HR',
            name        : 'ホロスコープかにざワンピ',
            imgUrl      : '/images/items/J6-08.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 2000,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-09',
            rare        : 'HR',
            name        : 'ホロスコープかにざシューズ',
            imgUrl      : '/images/items/J6-09.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 950,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-10',
            rare        : 'HR',
            name        : 'ホロスコープかにざヘアアクセ',
            imgUrl      : '/images/items/J6-10.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 950,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            rare        : 'HR',
          }),


          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-75',
            rare        : 'HR',
            name        : 'にんぎょひめターコイズトップス',
            imgUrl      : '/images/items/J6-75.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'PM',
            type        : 'PR',
            point       : 1100,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-76',
            rare        : 'HR',
            name        : 'にんぎょひめターコイズスカート',
            imgUrl      : '/images/items/J6-76.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'PM',
            type        : 'PR',
            point       : 1050,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-77',
            rare        : 'HR',
            name        : 'にんぎょひめターコイズシューズ',
            imgUrl      : '/images/items/J6-77.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : 'PM',
            type        : 'PR',
            point       : 950,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-78',
            rare        : 'HR',
            name        : 'にんぎょひめターコイズヘアアクセ',
            imgUrl      : '/images/items/J6-78.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'PM',
            type        : 'PR',
            point       : 950,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-79',
            rare        : 'HR',
            name        : 'ホロスコープうおざワンピ',
            imgUrl      : '/images/items/J6-79.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 2000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-80',
            rare        : 'HR',
            name        : 'ホロスコープうおざシューズ',
            imgUrl      : '/images/items/J6-80.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 950,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-81',
            rare        : 'HR',
            name        : 'ホロスコープうおざヘアアクセ',
            imgUrl      : '/images/items/J6-81.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 950,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            rare        : 'HR',
          }),


          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-82',
            rare        : 'HR',
            name        : 'ホロスコープふたござワンピ',
            imgUrl      : '/images/items/J6-82.png',
            kind        : 'ワンピース',
            color       : '茶',
            brand       : 'PM',
            type        : 'PR',
            point       : 2000,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-83',
            rare        : 'HR',
            name        : 'ホロスコープふたござシューズ',
            imgUrl      : '/images/items/J6-83.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : 'PM',
            type        : 'PR',
            point       : 950,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-84',
            rare        : 'HR',
            name        : 'ホロスコープふたござヘアアクセ',
            imgUrl      : '/images/items/J6-84.png',
            kind        : 'ヘアアクセ',
            color       : '茶',
            brand       : 'PM',
            type        : 'PR',
            point       : 950,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            rare        : 'HR',
          }),


          // [NOTE] PR
          // ================================================================================

          item({
            collection  : 'えもコレクション',
            id          : 'J6-11',
            rare        : 'PR',
            name        : 'フェアリートップス',
            imgUrl      : '/images/items/J6-11.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'CH',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-12',
            rare        : 'PR',
            name        : 'フェアリースカート',
            imgUrl      : '/images/items/J6-12.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'CH',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-13',
            rare        : 'PR',
            name        : 'フェアリーシューズ',
            imgUrl      : '/images/items/J6-13.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'CH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-14',
            rare        : 'PR',
            name        : 'フェアリーヘアアクセ',
            imgUrl      : '/images/items/J6-14.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'CH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'えもコレクション',
            id          : 'J6-15',
            rare        : 'PR',
            name        : 'ファンタジースノートップス',
            imgUrl      : '/images/items/J6-15.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'PM',
            type        : 'PR',
            point       : 850,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-16',
            rare        : 'PR',
            name        : 'ファンタジースノースカート',
            imgUrl      : '/images/items/J6-16.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'PM',
            type        : 'PR',
            point       : 900,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-17',
            rare        : 'PR',
            name        : 'ファンタジースノーシューズ',
            imgUrl      : '/images/items/J6-17.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'PM',
            type        : 'PR',
            point       : 800,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-18',
            rare        : 'PR',
            name        : 'ファンタジースノーヘアアクセ',
            imgUrl      : '/images/items/J6-18.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'PM',
            type        : 'PR',
            point       : 800,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'えもコレクション',
            id          : 'J6-19',
            rare        : 'PR',
            name        : 'レインボーライブトップス',
            imgUrl      : '/images/items/J6-19.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'DC',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-20',
            rare        : 'PR',
            name        : 'レインボーライブスカート',
            imgUrl      : '/images/items/J6-20.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'DC',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-21',
            rare        : 'PR',
            name        : 'レインボーライブシューズ',
            imgUrl      : '/images/items/J6-21.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'DC',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-22',
            rare        : 'PR',
            name        : 'レインボーライブヘアアクセ',
            imgUrl      : '/images/items/J6-22.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'DC',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-85',
            rare        : 'PR',
            name        : 'ファンタジースノーピンクトップス',
            imgUrl      : '/images/items/J6-85.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'PM',
            type        : 'PR',
            point       : 850,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-86',
            rare        : 'PR',
            name        : 'ファンタジースノーピンクスカート',
            imgUrl      : '/images/items/J6-86.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'PM',
            type        : 'PR',
            point       : 900,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-87',
            rare        : 'PR',
            name        : 'ファンタジースノーピンクシューズ',
            imgUrl      : '/images/items/J6-87.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'PM',
            type        : 'PR',
            point       : 800,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-88',
            rare        : 'PR',
            name        : 'ファンタジースノーピンクヘアアクセ',
            imgUrl      : '/images/items/J6-88.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'PM',
            type        : 'PR',
            point       : 800,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-89',
            rare        : 'PR',
            name        : 'フェアリーパープルトップス',
            imgUrl      : '/images/items/J6-89.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'CH',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-90',
            rare        : 'PR',
            name        : 'フェアリーパープルスカート',
            imgUrl      : '/images/items/J6-90.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'CH',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-91',
            rare        : 'PR',
            name        : 'フェアリーパープルシューズ',
            imgUrl      : '/images/items/J6-91.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'CH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-92',
            rare        : 'PR',
            name        : 'フェアリーパープルヘアアクセ',
            imgUrl      : '/images/items/J6-92.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'CH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-93',
            rare        : 'PR',
            name        : 'レインボーライブブルートップス',
            imgUrl      : '/images/items/J6-93.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'DC',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-94',
            rare        : 'PR',
            name        : 'レインボーライブブルースカート',
            imgUrl      : '/images/items/J6-94.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'DC',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-95',
            rare        : 'PR',
            name        : 'レインボーライブブルーシューズ',
            imgUrl      : '/images/items/J6-95.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'DC',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-96',
            rare        : 'PR',
            name        : 'レインボーライブブルーヘアアクセ',
            imgUrl      : '/images/items/J6-96.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'DC',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] SR
          // ================================================================================

          item({
            collection  : 'えもコレクション',
            id          : 'J6-23',
            rare        : 'SR',
            name        : 'ミルキーレインボーだいあアナザーワンピ',
            imgUrl      : '/images/items/J6-23.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : 'MR',
            type        : 'PO',
            point       : 1300,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-24',
            rare        : 'SR',
            name        : 'ミルキーレインボーだいあアナザーシューズ',
            imgUrl      : '/images/items/J6-24.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'MR',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-25',
            rare        : 'SR',
            name        : 'ミルキーレインボーだいあアナザーヘアアクセ',
            imgUrl      : '/images/items/J6-25.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'MR',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            rare        : 'SR',
          }),


          item({
            collection  : 'えもコレクション',
            id          : 'J6-26',
            rare        : 'SR',
            name        : 'バレンタインギフトトップス',
            imgUrl      : '/images/items/J6-26.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-27',
            rare        : 'SR',
            name        : 'バレンタインギフトスカート',
            imgUrl      : '/images/items/J6-27.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-28',
            rare        : 'SR',
            name        : 'バレンタインギフトシューズ',
            imgUrl      : '/images/items/J6-28.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-29',
            rare        : 'SR',
            name        : 'バレンタインギフトヘアアクセ',
            imgUrl      : '/images/items/J6-29.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'えもコレクション',
            id          : 'J6-30',
            rare        : 'SR',
            name        : 'ローズガーデンスイートトップス',
            imgUrl      : '/images/items/J6-30.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-31',
            rare        : 'SR',
            name        : 'ローズガーデンスイートスカート',
            imgUrl      : '/images/items/J6-31.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-32',
            rare        : 'SR',
            name        : 'ローズガーデンスイートシューズ',
            imgUrl      : '/images/items/J6-32.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-33',
            rare        : 'SR',
            name        : 'ローズガーデンスイートヘアアクセ',
            imgUrl      : '/images/items/J6-33.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'えもコレクション',
            id          : 'J6-34',
            rare        : 'SR',
            name        : 'グルーヴィダンサブルエールトップス',
            imgUrl      : '/images/items/J6-34.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'DS',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-35',
            rare        : 'SR',
            name        : 'グルーヴィダンサブルエールスカート',
            imgUrl      : '/images/items/J6-35.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-36',
            rare        : 'SR',
            name        : 'グルーヴィダンサブルエールシューズ',
            imgUrl      : '/images/items/J6-36.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'DS',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-37',
            rare        : 'SR',
            name        : 'グルーヴィダンサブルエールヘアアクセ',
            imgUrl      : '/images/items/J6-37.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'DS',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'えもコレクション',
            id          : 'J6-38',
            rare        : 'SR',
            name        : 'ファンシーレースアップシークレットトップス',
            imgUrl      : '/images/items/J6-38.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-39',
            rare        : 'SR',
            name        : 'ファンシーレースアップシークレットスカート',
            imgUrl      : '/images/items/J6-39.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-40',
            rare        : 'SR',
            name        : 'ファンシーレースアップシークレットシューズ',
            imgUrl      : '/images/items/J6-40.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えもコレクション',
            id          : 'J6-41',
            rare        : 'SR',
            name        : 'ファンシーレースアップシークレットヘアアクセ',
            imgUrl      : '/images/items/J6-41.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-97',
            rare        : 'SR',
            name        : 'トリッキーキャンディトップス',
            imgUrl      : '/images/items/J6-97.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-98',
            rare        : 'SR',
            name        : 'トリッキーキャンディスカート',
            imgUrl      : '/images/items/J6-98.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'MR',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-99',
            rare        : 'SR',
            name        : 'トリッキーキャンディシューズ',
            imgUrl      : '/images/items/J6-99.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'MR',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-100',
            rare        : 'SR',
            name        : 'トリッキーキャンディヘアアクセ',
            imgUrl      : '/images/items/J6-100.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'MR',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-101',
            rare        : 'SR',
            name        : 'ホワイトデーギフトトップス',
            imgUrl      : '/images/items/J6-101.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-102',
            rare        : 'SR',
            name        : 'ホワイトデーギフトスカート',
            imgUrl      : '/images/items/J6-102.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-103',
            rare        : 'SR',
            name        : 'ホワイトデーギフトシューズ',
            imgUrl      : '/images/items/J6-103.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-104',
            rare        : 'SR',
            name        : 'ホワイトデーギフトヘアアクセ',
            imgUrl      : '/images/items/J6-104.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-105',
            rare        : 'SR',
            name        : 'プリティーリボンクラシックレッドトップス',
            imgUrl      : '/images/items/J6-105.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-106',
            rare        : 'SR',
            name        : 'プリティーリボンクラシックレッドスカート',
            imgUrl      : '/images/items/J6-106.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-107',
            rare        : 'SR',
            name        : 'プリティーリボンクラシックレッドシューズ',
            imgUrl      : '/images/items/J6-107.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-108',
            rare        : 'SR',
            name        : 'プリティーリボンクラシックレッドヘアアクセ',
            imgUrl      : '/images/items/J6-108.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-109',
            rare        : 'SR',
            name        : 'プリティーリボンクラシックグリーントップス',
            imgUrl      : '/images/items/J6-109.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-110',
            rare        : 'SR',
            name        : 'プリティーリボンクラシックグリーンスカート',
            imgUrl      : '/images/items/J6-110.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-111',
            rare        : 'SR',
            name        : 'プリティーリボンクラシックグリーンシューズ',
            imgUrl      : '/images/items/J6-111.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-112',
            rare        : 'SR',
            name        : 'プリティーリボンクラシックグリーンヘアアクセ',
            imgUrl      : '/images/items/J6-112.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-113',
            rare        : 'SR',
            name        : 'プリティーリボンクラシックパープルトップス',
            imgUrl      : '/images/items/J6-113.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-114',
            rare        : 'SR',
            name        : 'プリティーリボンクラシックパープルスカート',
            imgUrl      : '/images/items/J6-114.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-115',
            rare        : 'SR',
            name        : 'プリティーリボンクラシックパープルシューズ',
            imgUrl      : '/images/items/J6-115.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ダイヤモンドコレクション',
            id          : 'J6-116',
            rare        : 'SR',
            name        : 'プリティーリボンクラシックパープルヘアアクセ',
            imgUrl      : '/images/items/J6-116.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] SR モーリーファンタジー限定
          // ================================================================================

          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-47',
            rare        : 'SR',
            name        : 'フェアリーブルートップス',
            imgUrl      : '/images/items/MF-47.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'CH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-48',
            rare        : 'SR',
            name        : 'フェアリーブルースカート',
            imgUrl      : '/images/items/MF-48.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'CH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-49',
            rare        : 'SR',
            name        : 'フェアリーブルーシューズ',
            imgUrl      : '/images/items/MF-49.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'CH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-50',
            rare        : 'SR',
            name        : 'フェアリーブルーヘアアクセ',
            imgUrl      : '/images/items/MF-50.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'CH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),


          // [NOTE] R
          // ================================================================================

          item({
            collection  : '共通',
            id          : 'J6-43',
            rare        : 'R',
            name        : 'スターダストレッドグラデワンピ',
            imgUrl      : '/images/items/J6-43.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 1000,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J6-44',
            rare        : 'R',
            name        : 'スターダストレッドグラデシューズ',
            imgUrl      : '/images/items/J6-44.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J6-45',
            rare        : 'R',
            name        : 'スターダストレッドグラデヘアアクセ',
            imgUrl      : '/images/items/J6-45.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'R',
          }),


          item({
            collection  : '共通',
            id          : 'J6-46',
            rare        : 'R',
            name        : 'ロック＆ビートブラックセットアップ',
            imgUrl      : '/images/items/J6-46.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 1000,
            numOwned    : { usual: 10 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J6-47',
            rare        : 'R',
            name        : 'ロック＆ビートブラックシューズ',
            imgUrl      : '/images/items/J6-47.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J6-48',
            rare        : 'R',
            name        : 'ロック＆ビートブラックサングラス',
            imgUrl      : '/images/items/J6-48.png',
            kind        : '',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'R',
          }),


          item({
            collection  : '共通',
            id          : 'J6-49',
            rare        : 'R',
            name        : 'ミステリアスレディトップス',
            imgUrl      : '/images/items/J6-49.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J6-50',
            rare        : 'R',
            name        : 'ミステリアスレディスカート',
            imgUrl      : '/images/items/J6-50.png',
            kind        : 'スカート',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J6-51',
            rare        : 'R',
            name        : 'ミステリアスレディシューズ',
            imgUrl      : '/images/items/J6-51.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J6-52',
            rare        : 'R',
            name        : 'ミステリアスレディヘアアクセ',
            imgUrl      : '/images/items/J6-52.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'J6-53',
            rare        : 'R',
            name        : 'ウィンターガーリートップス',
            imgUrl      : '/images/items/J6-53.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J6-54',
            rare        : 'R',
            name        : 'ウィンターガーリースカート',
            imgUrl      : '/images/items/J6-54.png',
            kind        : 'スカート',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J6-55',
            rare        : 'R',
            name        : 'ウィンターガーリーシューズ',
            imgUrl      : '/images/items/J6-55.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J6-56',
            rare        : 'R',
            name        : 'ウィンターガーリーヘアアクセ',
            imgUrl      : '/images/items/J6-56.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'CH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'J6-57',
            rare        : 'R',
            name        : 'ストライプビッグシルエットイエローパーカ',
            imgUrl      : '/images/items/J6-57.png',
            kind        : 'ワンピース',
            color       : '黄',
            brand       : 'DS',
            type        : 'CO',
            point       : 1000,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J6-58',
            rare        : 'R',
            name        : 'ストライプイエロースニーカー',
            imgUrl      : '/images/items/J6-58.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'DS',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J6-59',
            rare        : 'R',
            name        : 'ストライプサンバイザーイエローヘアアクセ',
            imgUrl      : '/images/items/J6-59.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'DS',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'R',
          }),


          // [NOTE] N
          // ================================================================================

          item({
            collection  : '共通',
            id          : 'J6-60',
            rare        : 'N',
            name        : 'ゆるかわスウェットトップス',
            imgUrl      : '/images/items/J6-60.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 10 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J6-61',
            rare        : 'N',
            name        : 'ゆるかわスウェットスカート',
            imgUrl      : '/images/items/J6-61.png',
            kind        : 'スカート',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 400,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J6-62',
            rare        : 'N',
            name        : 'ゆるかわスウェットシューズ',
            imgUrl      : '/images/items/J6-62.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J6-63',
            rare        : 'N',
            name        : 'ゆるかわスウェットヘアアクセ',
            imgUrl      : '/images/items/J6-63.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'J6-64',
            rare        : 'N',
            name        : 'イエローローズトップス',
            imgUrl      : '/images/items/J6-64.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'DW',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J6-65',
            rare        : 'N',
            name        : 'イエローローズスカート',
            imgUrl      : '/images/items/J6-65.png',
            kind        : 'スカート',
            color       : '黄',
            brand       : 'DW',
            type        : 'LO',
            point       : 400,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J6-66',
            rare        : 'N',
            name        : 'イエローローズシューズ',
            imgUrl      : '/images/items/J6-66.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'DW',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J6-67',
            rare        : 'N',
            name        : 'イエローローズヘアアクセ',
            imgUrl      : '/images/items/J6-67.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'DW',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'J6-68',
            rare        : 'N',
            name        : 'ガーデンフラワーパープルトップス',
            imgUrl      : '/images/items/J6-68.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 450,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J6-69',
            rare        : 'N',
            name        : 'ガーデンフラワーパープルスカート',
            imgUrl      : '/images/items/J6-69.png',
            kind        : 'スカート',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 400,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J6-70',
            rare        : 'N',
            name        : 'ガーデンフラワーパープルシューズ',
            imgUrl      : '/images/items/J6-70.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 350,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J6-71',
            rare        : 'N',
            name        : 'ガーデンフラワーパープルヘアアクセ',
            imgUrl      : '/images/items/J6-71.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 350,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'J6-72',
            rare        : 'N',
            name        : 'ファーチェックそらいろワンピ',
            imgUrl      : '/images/items/J6-72.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J6-73',
            rare        : 'N',
            name        : 'ファーチェックそらいろシューズ',
            imgUrl      : '/images/items/J6-73.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J6-74',
            rare        : 'N',
            name        : 'ファーチェックそらいろヘアアクセ',
            imgUrl      : '/images/items/J6-74.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'N',
          }),


          // [NOTE] パシャッとアイテム
          // ================================================================================

          item({
            collection  : '共通',
            id          : 'J6-42',
            rare        : 'SR',
            name        : 'げんしじんのおにく',
            imgUrl      : '/images/items/J6-42.png',
            kind        : 'パシャッとアイテム',
            color       : '茶',
            brand       : 'UQ',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] ブランドランク
          // ================================================================================


          // [NOTE] プレゼントボックス
          // ================================================================================

          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-42',
            rare        : 'Ｎ',
            name        : 'パステルリボンニット',
            imgUrl      : '/images/items/PB-42_.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-43',
            rare        : 'Ｎ',
            name        : 'パステルふんわりスカート',
            imgUrl      : '/images/items/PB-43.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-44',
            rare        : 'Ｎ',
            name        : 'アーガイルソックス&ファーブーツ',
            imgUrl      : '/images/items/PB-44.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-44:after1',
            rare        : 'Ｎ',
          }),


          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-45',
            rare        : 'Ｎ',
            name        : 'PSスクールガールカジュアルニット',
            imgUrl      : '/images/items/PB-45.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : '',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-46',
            rare        : 'Ｎ',
            name        : 'シンプルデニムミニスカ',
            imgUrl      : '/images/items/PB-46.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-47',
            rare        : 'Ｎ',
            name        : 'カジュアルポップンスニーカー',
            imgUrl      : '/images/items/PB-47.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : '',
            type        : 'LO',
            point       : 300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-47:after1',
            rare        : 'Ｎ',
          }),


          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-49',
            rare        : 'Ｎ',
            name        : 'ウルトラマリンチェックワンピ',
            imgUrl      : '/images/items/PB-49.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-50',
            rare        : 'Ｎ',
            name        : 'クラシックタイツ＆ヒールローファー',
            imgUrl      : '/images/items/PB-50.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-50:after1',
            rare        : 'Ｎ',
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-50:after2',
            rare        : 'Ｎ',
          }),


          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-51',
            rare        : 'Ｎ',
            name        : 'サスペンダーストライプシャツ',
            imgUrl      : '/images/items/PB-51.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-52',
            rare        : 'Ｎ',
            name        : 'チェーンつきハーフパンツ',
            imgUrl      : '/images/items/PB-52.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-53',
            rare        : 'Ｎ',
            name        : 'シックシンプルブーティ',
            imgUrl      : '/images/items/PB-53.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-53:after1',
            rare        : 'Ｎ',
          }),


          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-54',
            rare        : 'Ｎ',
            name        : 'カフェラテレディコート',
            imgUrl      : '/images/items/PB-54.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-55',
            rare        : 'Ｎ',
            name        : 'ナチュラルニーハイ＆レッドシューズ',
            imgUrl      : '/images/items/PB-55.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-55:after1',
            rare        : 'Ｎ',
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-55:after2',
            rare        : 'Ｎ',
          }),


          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-57',
            rare        : 'Ｎ',
            name        : 'アーガイルビリジアントップス',
            imgUrl      : '/images/items/PB-57.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : '',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-58',
            rare        : 'Ｎ',
            name        : 'アーガイルビリジアンスカート',
            imgUrl      : '/images/items/PB-58.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : '',
            type        : 'LO',
            point       : 400,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-59',
            rare        : 'Ｎ',
            name        : 'アーガイルビリジアンシューズ',
            imgUrl      : '/images/items/PB-59.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : '',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-60',
            rare        : 'Ｎ',
            name        : 'アーガイルビリジアンヘアアクセ',
            imgUrl      : '/images/items/PB-60.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : '',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-61',
            rare        : 'R',
            name        : 'サイリウムタクト',
            imgUrl      : '/images/items/PB-61.png',
            kind        : 'パシャッとアイテム',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-62',
            rare        : 'R',
            name        : 'アイドルタイムハープ',
            imgUrl      : '/images/items/PB-62.png',
            kind        : 'パシャッとアイテム',
            color       : '緑',
            brand       : '',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'プレゼントボックス',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] バレンタインチャンネル
          // ================================================================================

          item({
            collection  : 'バレンタインチャンネル',
            id          : 'J6-117',
            rare        : 'SR',
            name        : 'バレンタインギフトパステルトップス',
            imgUrl      : '/images/items/J6-117.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'バレンタインチャンネル',
            id          : 'J6-118',
            rare        : 'SR',
            name        : 'バレンタインギフトパステルスカート',
            imgUrl      : '/images/items/J6-118.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'バレンタインチャンネル',
            id          : 'J6-119',
            rare        : 'SR',
            name        : 'バレンタインギフトパステルシューズ',
            imgUrl      : '/images/items/J6-119.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'バレンタインチャンネル',
            id          : 'J6-120',
            rare        : 'SR',
            name        : 'バレンタインギフトパステルヘアアクセ',
            imgUrl      : '/images/items/J6-120.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'バレンタインチャンネル',
            id          : 'J6-121',
            rare        : 'SR',
            name        : 'ハートフルバレンタインピンクトップス',
            imgUrl      : '/images/items/J6-121.png',
            kind        : 'トップス',
            color       : '茶',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'バレンタインチャンネル',
            id          : 'J6-122',
            rare        : 'SR',
            name        : 'ハートフルバレンタインピンクスカート',
            imgUrl      : '/images/items/J6-122.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'バレンタインチャンネル',
            id          : 'J6-123',
            rare        : 'SR',
            name        : 'ハートフルバレンタインピンクシューズ',
            imgUrl      : '/images/items/J6-123.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'バレンタインチャンネル',
            id          : 'J6-124',
            rare        : 'SR',
            name        : 'ハートフルバレンタインピンクヘアアクセ',
            imgUrl      : '/images/items/J6-124.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] ジュエルコレクション
          // ================================================================================

          item({
            collection  : 'ジュエルコレクション',
            id          : 'JR11-01',
            rare        : 'JR',
            name        : 'ダイヤモンドジュエルドレス',
            imgUrl      : '/images/items/JR11-01.png',
            kind        : 'ワンピース',
            color       : '虹',
            brand       : 'MR',
            type        : 'PO',
            point       : 1900,
            numOwned    : { kira: 2, usual: 4 },
            numReleased : { kira: 0, usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ジュエルコレクション',
            id          : 'JR11-02',
            rare        : 'JR',
            name        : 'ダイヤモンドジュエルシューズ',
            imgUrl      : '/images/items/JR11-02.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'MR',
            type        : 'PO',
            point       : 800,
            numOwned    : { kira: 1, usual: 4 },
            numReleased : { kira: 0, usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ジュエルコレクション',
            id          : 'JR11-03',
            rare        : 'JR',
            name        : 'ダイヤモンドジュエルヘアアクセ',
            imgUrl      : '/images/items/JR11-03.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'MR',
            type        : 'PO',
            point       : 800,
            numOwned    : { kira: 2, usual: 4 },
            numReleased : { kira: 0, usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ジュエルコレクション',
            id          : 'PB-63',
            rare        : 'SR',
            name        : 'ダイヤモンドジュエルのたて',
            imgUrl      : '/images/items/PB-63.png',
            kind        : 'パシャッとアイテム',
            color       : '虹',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] ジュエルパクト
          // ================================================================================

          externalItem(itemsPromo2019Pact, 'JP-224', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-225', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-226', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-227', { collection: 'ジュエルパクト' }),


          // [NOTE] ニコチケ PR
          // ================================================================================

          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-01',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムガァルルアナザーワンピ',
            imgUrl      : '/images/items/NC-J6-01.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 1600,
            numOwned    : { nico: 4 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-02',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムガァルルアナザーシューズ',
            imgUrl      : '/images/items/NC-J6-02.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'LO',
            point       : 800,
            aggregation : 'NC-J6-01',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-03',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムガァルルアナザーヘアアクセ',
            imgUrl      : '/images/items/NC-J6-03.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : '',
            type        : 'LO',
            point       : 800,
            aggregation : 'NC-J6-01',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'PR',
          }),


          // [NOTE] ニコチケ SR
          // ================================================================================

          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-04',
            rare        : 'SR',
            name        : 'チームゆめサイリウムにのアナザーワンピ',
            imgUrl      : '/images/items/NC-J6-04.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : '',
            type        : 'PO',
            point       : 1300,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-05',
            rare        : 'SR',
            name        : 'チームゆめサイリウムにのアナザーシューズ',
            imgUrl      : '/images/items/NC-J6-05.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'PO',
            point       : 650,
            aggregation : 'NC-J6-04',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-06',
            rare        : 'SR',
            name        : 'チームゆめサイリウムにのアナザーヘアアクセ',
            imgUrl      : '/images/items/NC-J6-06.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : '',
            type        : 'PO',
            point       : 650,
            aggregation : 'NC-J6-04',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'SR',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-07',
            rare        : 'SR',
            name        : 'シルキーハートパープルサイリウムワンピ',
            imgUrl      : '/images/items/NC-J6-07.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : '',
            type        : 'LO',
            point       : 1300,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-08',
            rare        : 'SR',
            name        : 'シルキーハートパープルサイリウムシューズ',
            imgUrl      : '/images/items/NC-J6-08.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : '',
            type        : 'LO',
            point       : 650,
            aggregation : 'NC-J6-07',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-09',
            rare        : 'SR',
            name        : 'シルキーハートパープルサイリウムヘアアクセ',
            imgUrl      : '/images/items/NC-J6-09.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : '',
            type        : 'LO',
            point       : 650,
            aggregation : 'NC-J6-07',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'SR',
          }),


          // [NOTE] ニコチケ R
          // ================================================================================

          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-10',
            rare        : 'R',
            name        : 'シューティングスターワンピ',
            imgUrl      : '/images/items/NC-J6-10.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 1000,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-11',
            rare        : 'R',
            name        : 'シューティングスターシューズ',
            imgUrl      : '/images/items/NC-J6-11.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-J6-10',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-12',
            rare        : 'R',
            name        : 'シューティングスターヘアアクセ',
            imgUrl      : '/images/items/NC-J6-12.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : '',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-J6-10',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-13',
            rare        : 'R',
            name        : 'ねこうらないしスターワンピ',
            imgUrl      : '/images/items/NC-J6-13.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'UQ',
            type        : 'CO',
            point       : 1000,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-14',
            rare        : 'R',
            name        : 'ねこうらないしスターシューズ',
            imgUrl      : '/images/items/NC-J6-14.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J6-13',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-15',
            rare        : 'R',
            name        : 'ねこうらないしスターヘアアクセ',
            imgUrl      : '/images/items/NC-J6-15.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J6-13',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-16',
            rare        : 'R',
            name        : 'プリティーリボンスタートップス',
            imgUrl      : '/images/items/NC-J6-16.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-17',
            rare        : 'R',
            name        : 'プリティーリボンスタースカート',
            imgUrl      : '/images/items/NC-J6-17.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            aggregation : 'NC-J6-16',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-18',
            rare        : 'R',
            name        : 'プリティーリボンスターシューズ',
            imgUrl      : '/images/items/NC-J6-18.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J6-16',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-19',
            rare        : 'R',
            name        : 'プリティーリボンスターヘアアクセ',
            imgUrl      : '/images/items/NC-J6-19.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J6-16',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-20',
            rare        : 'R',
            name        : 'ミステリーチェックピンキートップス',
            imgUrl      : '/images/items/NC-J6-20.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 550,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-21',
            rare        : 'R',
            name        : 'ミステリーチェックピンキーミニスカ',
            imgUrl      : '/images/items/NC-J6-21.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 600,
            aggregation : 'NC-J6-20',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-22',
            rare        : 'R',
            name        : 'ミステリーチェックピンキーシューズ',
            imgUrl      : '/images/items/NC-J6-22.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-J6-20',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-23',
            rare        : 'R',
            name        : 'クラシックチェックピンキートップス',
            imgUrl      : '/images/items/NC-J6-23.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 550,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-24',
            rare        : 'R',
            name        : 'クラシックチェックピンキースカート',
            imgUrl      : '/images/items/NC-J6-24.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            aggregation : 'NC-J6-23',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-25',
            rare        : 'R',
            name        : 'クラシックチェックピンキーシューズ',
            imgUrl      : '/images/items/NC-J6-25.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'SA',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J6-23',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-26',
            rare        : 'R',
            name        : 'クラシックチェックピンキーヘアアクセ',
            imgUrl      : '/images/items/NC-J6-26.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J6-23',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-27',
            rare        : 'R',
            name        : 'スペードチェックピンキーワンピ',
            imgUrl      : '/images/items/NC-J6-27.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'SA',
            type        : 'CO',
            point       : 1000,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-28',
            rare        : 'R',
            name        : 'スペードチェックピンキーシューズ',
            imgUrl      : '/images/items/NC-J6-28.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'SA',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J6-27',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-29',
            rare        : 'R',
            name        : 'スペードチェックピンキーヘアアクセ',
            imgUrl      : '/images/items/NC-J6-29.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J6-27',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-30',
            rare        : 'R',
            name        : 'スペードチェックレッドワンピ',
            imgUrl      : '/images/items/NC-J6-30.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 1000,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-31',
            rare        : 'R',
            name        : 'スペードチェックレッドシューズ',
            imgUrl      : '/images/items/NC-J6-31.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J6-30',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-32',
            rare        : 'R',
            name        : 'スペードチェックレッドヘアアクセ',
            imgUrl      : '/images/items/NC-J6-32.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J6-30',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-33',
            rare        : 'R',
            name        : 'スペードチェックグリーンワンピ',
            imgUrl      : '/images/items/NC-J6-33.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 1000,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-34',
            rare        : 'R',
            name        : 'スペードチェックグリーンシューズ',
            imgUrl      : '/images/items/NC-J6-34.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J6-33',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-35',
            rare        : 'R',
            name        : 'スペードチェックグリーンヘアアクセ',
            imgUrl      : '/images/items/NC-J6-35.png',
            kind        : 'ヘアアクセ',
            color       : '茶',
            brand       : 'SA',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J6-33',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-36',
            rare        : 'R',
            name        : 'タピオカミルクティーワンピ',
            imgUrl      : '/images/items/NC-J6-36.png',
            kind        : 'ワンピース',
            color       : '茶',
            brand       : 'SA',
            type        : 'CO',
            point       : 1000,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-37',
            rare        : 'R',
            name        : 'タピオカミルクティーシューズ',
            imgUrl      : '/images/items/NC-J6-37.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : 'SA',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J6-36',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-38',
            rare        : 'R',
            name        : 'タピオカミルクティーヘアアクセ',
            imgUrl      : '/images/items/NC-J6-38.png',
            kind        : 'ヘアアクセ',
            color       : '茶',
            brand       : 'SA',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J6-36',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-39',
            rare        : 'R',
            name        : 'カレーハウススパイシートップス',
            imgUrl      : '/images/items/NC-J6-39.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-40',
            rare        : 'R',
            name        : 'カレーハウススパイシースカート',
            imgUrl      : '/images/items/NC-J6-40.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            aggregation : 'NC-J6-39',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-41',
            rare        : 'R',
            name        : 'カレーハウススパイシーシューズ',
            imgUrl      : '/images/items/NC-J6-41.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-J6-39',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-42',
            rare        : 'R',
            name        : 'カレーハウススパイシーヘアアクセ',
            imgUrl      : '/images/items/NC-J6-42.png',
            kind        : 'ヘアアクセ',
            color       : '茶',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-J6-39',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-43',
            rare        : 'R',
            name        : 'ナポリタンアツアツワンピ',
            imgUrl      : '/images/items/NC-J6-43.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'MR',
            type        : 'PO',
            point       : 1000,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-44',
            rare        : 'R',
            name        : 'ナポリタンアツアツシューズ',
            imgUrl      : '/images/items/NC-J6-44.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'MR',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-J6-43',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-45',
            rare        : 'R',
            name        : 'ナポリタンアツアツヘアアクセ',
            imgUrl      : '/images/items/NC-J6-45.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'MR',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-J6-43',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-46',
            rare        : 'R',
            name        : 'ゆきだるまわくわくワンピ',
            imgUrl      : '/images/items/NC-J6-46.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 1000,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-47',
            rare        : 'R',
            name        : 'ゆきだるまわくわくシューズ',
            imgUrl      : '/images/items/NC-J6-47.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J6-46',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-48',
            rare        : 'R',
            name        : 'ゆきだるまわくわくヘアアクセ',
            imgUrl      : '/images/items/NC-J6-48.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J6-46',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-49',
            rare        : 'R',
            name        : 'げんしじんワイルドトップス',
            imgUrl      : '/images/items/NC-J6-49.png',
            kind        : 'トップス',
            color       : '茶',
            brand       : 'UQ',
            type        : 'CO',
            point       : 550,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-50',
            rare        : 'R',
            name        : 'げんしじんワイルドパンツ',
            imgUrl      : '/images/items/NC-J6-50.png',
            kind        : 'ボトムス',
            color       : '茶',
            brand       : 'UQ',
            type        : 'CO',
            point       : 600,
            aggregation : 'NC-J6-49',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-51',
            rare        : 'R',
            name        : 'げんしじんワイルドシューズ',
            imgUrl      : '/images/items/NC-J6-51.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : 'UQ',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J6-49',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J6-52',
            rare        : 'R',
            name        : 'げんしじんワイルドヘアアクセ',
            imgUrl      : '/images/items/NC-J6-52.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J6-49',
          }),


          // [NOTE] ニコチケ二択目 PR
          // ================================================================================

          nico2Item('NC-J5-90'),
          nico2Item('NC-J5-91'),
          nico2Spacer('PR'),
          nico2Spacer('PR'),


          nico2Item('NC-J5-92'),
          nico2Item('NC-J5-93'),
          nico2Spacer('PR'),
          nico2Spacer('PR'),


          nico2Item('NC-J5-94'),
          nico2Item('NC-J5-95'),
          nico2Spacer('PR'),
          nico2Spacer('PR'),


          nico2Item('NC-J5-96'),
          nico2Item('NC-J5-97'),
          nico2Item('NC-J5-98'),
          nico2Spacer('PR'),


          // [NOTE] ニコチケ二択目 SR
          // ================================================================================

          nico2Item('NC-J5-99'),
          nico2Item('NC-J5-100'),
          nico2Spacer('SR'),
          nico2Spacer('SR'),


          nico2Item('NC-J5-101'),
          nico2Item('NC-J5-102'),
          nico2Spacer('SR'),
          nico2Spacer('SR'),


          nico2Item('NC-J5-103'),
          nico2Item('NC-J5-104'),
          nico2Spacer('SR'),
          nico2Spacer('SR'),


          nico2Item('NC-J5-105'),
          nico2Item('NC-J5-106'),
          nico2Spacer('SR'),
          nico2Spacer('SR'),


          nico2Item('NC-J5-107'),
          nico2Item('NC-J5-108'),
          nico2Spacer('SR'),
          nico2Spacer('SR'),


          nico2Item('NC-J5-109'),
          nico2Item('NC-J5-110'),
          nico2Spacer('SR'),
          nico2Spacer('SR'),


          nico2Item('NC-J5-111'),
          nico2Item('NC-J5-112'),
          nico2Spacer('SR'),
          nico2Spacer('SR'),


          nico2Item('NC-J5-113'),
          nico2Item('NC-J5-114'),
          nico2Spacer('SR'),
          nico2Spacer('SR'),


          nico2Item('NC-J5-115'),
          nico2Item('NC-J5-116'),
          nico2Spacer('SR'),
          nico2Spacer('SR'),


          nico2Item('NC-J5-117'),
          nico2Item('NC-J5-118'),
          nico2Spacer('SR'),
          nico2Spacer('SR'),


          nico2Item('NC-J5-119'),
          nico2Item('NC-J5-120'),
          nico2Spacer('SR'),
          nico2Spacer('SR'),


          nico2Item('NC-J5-121'),
          nico2Item('NC-J5-122'),
          nico2Spacer('SR'),
          nico2Spacer('SR'),


          nico2Item('NC-J5-123'),
          nico2Item('NC-J5-124'),
          nico2Spacer('SR'),
          nico2Spacer('SR'),


          nico2Item('NC-J5-125'),
          nico2Item('NC-J5-126'),
          nico2Spacer('SR'),
          nico2Spacer('SR'),


          // [NOTE] ニコチケ二択目 R
          // ================================================================================

          nico2Item('NC-J5-127'),
          nico2Item('NC-J5-128'),
          nico2Item('NC-J5-129'),
          nico2Spacer('R'),


          nico2Item('NC-J5-130'),
          nico2Item('NC-J5-131'),
          nico2Item('NC-J5-132'),
          nico2Spacer('R'),


          nico2Item('NC-J5-133'),
          nico2Item('NC-J5-134'),
          nico2Item('NC-J5-135'),
          nico2Spacer('R'),


          nico2Item('NC-J5-136'),
          nico2Item('NC-J5-137'),
          nico2Item('NC-J5-138'),
          nico2Spacer('R'),


          nico2Item('NC-J5-139'),
          nico2Item('NC-J5-140'),
          nico2Item('NC-J5-141'),
          nico2Spacer('R'),


          nico2Item('NC-J5-142'),
          nico2Item('NC-J5-143'),
          nico2Item('NC-J5-144'),
          nico2Spacer('R'),


          nico2Item('NC-J5-145'),
          nico2Item('NC-J5-146'),
          nico2Item('NC-J5-147'),
          nico2Item('NC-J5-148'),


          nico2Item('NC-J5-149'),
          nico2Item('NC-J5-150'),
          nico2Item('NC-J5-151'),
          nico2Item('NC-J5-152'),


          nico2Item('NC-J5-153'),
          nico2Item('NC-J5-154'),
          nico2Item('NC-J5-155'),
          nico2Item('NC-J5-156'),


          nico2Item('NC-J5-157'),
          nico2Item('NC-J5-158'),
          nico2Spacer('R'),
          nico2Spacer('R'),


          nico2Item('NC-J5-159'),
          nico2Item('NC-J5-160'),
          nico2Spacer('R'),
          nico2Spacer('R'),


          nico2Item('NC-J5-161'),
          nico2Item('NC-J5-162'),
          nico2Item('NC-J5-163'),
          nico2Spacer('R'),


          nico2Item('NC-J5-164'),
          nico2Item('NC-J5-165'),
          nico2Spacer('R'),
          nico2Spacer('R'),


          nico2Item('NC-J5-166'),
          nico2Item('NC-J5-167'),
          nico2Spacer('R'),
          nico2Spacer('R'),


          nico2Item('NC-J5-168'),
          nico2Item('NC-J5-169'),
          nico2Item('NC-J5-170'),
          nico2Spacer('R'),


          nico2Item('NC-J5-171'),
          nico2Item('NC-J5-172'),
          nico2Item('NC-J5-173'),
          nico2Spacer('R'),


          nico2Item('NC-J5-174'),
          nico2Item('NC-J5-175'),
          nico2Item('NC-J5-176'),
          nico2Spacer('R'),


          nico2Item('NC-J5-177'),
          nico2Item('NC-J5-178'),
          nico2Spacer('R'),
          nico2Spacer('R'),


          nico2Item('NC-J5-179'),
          nico2Item('NC-J5-180'),
          nico2Spacer('R'),
          nico2Spacer('R'),


          // [NOTE] ニコチケ二択目 N
          // ================================================================================

          nico2Item('NC-J5-181'),
          nico2Item('NC-J5-182'),
          nico2Item('NC-J5-183'),
          nico2Spacer('N'),


          nico2Item('NC-J5-184'),
          nico2Item('NC-J5-185'),
          nico2Item('NC-J5-186'),
          nico2Spacer('N'),


          nico2Item('NC-J5-187'),
          nico2Item('NC-J5-188'),
          nico2Item('NC-J5-189'),
          nico2Spacer('N'),


          nico2Item('NC-J5-190'),
          nico2Item('NC-J5-191'),
          nico2Spacer('N'),
          nico2Spacer('N'),


          nico2Item('NC-J5-192'),
          nico2Item('NC-J5-193'),
          nico2Item('NC-J5-194'),
          nico2Spacer('N'),


          nico2Item('NC-J5-195'),
          nico2Item('NC-J5-196'),
          nico2Item('NC-J5-197'),
          nico2Spacer('N'),


          nico2Item('NC-J5-198'),
          nico2Item('NC-J5-199'),
          nico2Item('NC-J5-200'),
          nico2Spacer('N'),


          nico2Item('NC-J5-201'),
          nico2Item('NC-J5-202'),
          nico2Item('NC-J5-203'),
          nico2Spacer('N'),


          // [NOTE] スペシャルキラニコチケキャンペーン
          // ================================================================================

          externalItem(itemsPromo2019Events, 'P-NC-005'  , { collection: 'SpKiraNico' }),
          externalItem(itemsPromo2019Events, 'P-NC-005-S', { collection: 'SpKiraNico' }),
          externalItem(itemsPromo2019Events, 'P-NC-005-H', { collection: 'SpKiraNico' }),
          item({
            collection  : 'SpKiraNico',
            rare        : 'JR',
          }),


        ],
      }
    },

    computed: {
      itemsFiltered () {
        const { excepts, items } = this
        return excepts.length
          ? items.filter(item => !excepts.includes(item.collection) )
          : items
      },

      itemsMaJor () {
        const { major, itemsFiltered, itemsPasha } = this
        return itemsFiltered.filter(item => major.includes(item.collection) && !itemsPasha.includes(item))
      },

      itemsJR10 () {
        return _.where(this.itemsMaJor, { rare: 'JR', collection: 'えもコレクション' })
      },

      itemsRR () {
        return _.where(this.itemsMaJor, { rare: 'RR' })
      },

      itemsHR () {
        return _.where(this.itemsMaJor, { rare: 'HR' })
      },

      itemsPR () {
        return _.where(this.itemsMaJor, { rare: 'PR' })
      },

      itemsSR () {
        return _.where(this.itemsMaJor, { rare: 'SR' })
      },

      itemsR () {
        return _.where(this.itemsMaJor, { rare: 'R' })
      },

      itemsN () {
        return _.where(this.itemsMaJor, { rare: 'N' })
      },

      itemsPasha () {
        return _.where(this.itemsFiltered, { kind: 'パシャッとアイテム' }).filter(item => this.major.includes(item.collection) )
      },

      itemsBrandRank () {
        return _.where(this.itemsFiltered, { collection: 'ブランドランク' })
      },

      itemsPBox () {
        return _.where(this.itemsFiltered, { collection: 'プレゼントボックス' })
      },

      itemsJewelPact () {
        return _.where(this.itemsFiltered, { collection: 'ジュエルパクト' })
      },

      itemsDesignPalette () {
        return _.where(this.itemsFiltered, { collection: 'デザインパレット自作' })
      },

      itemsMolly () {
        return _.where(this.itemsFiltered, { collection: 'モーリーファンタジー限定' })
      },

      itemsValentineChannel () {
        return _.where(this.itemsFiltered, { collection: 'バレンタインチャンネル' })
      },

      itemsJewelCollection () {
        return _.where(this.itemsFiltered, { collection: 'ジュエルコレクション' })
      },

      itemsNico () {
        return _.where(this.itemsFiltered, { collection: 'ニコチケ' })
      },

      itemsNicoPR () {
        return _.where(this.itemsNico, { rare: 'PR' })
      },

      itemsNicoSR () {
        return _.where(this.itemsNico, { rare: 'SR' })
      },

      itemsNicoR () {
        return _.where(this.itemsNico, { rare: 'R' })
      },

      itemsNicoN () {
        return _.where(this.itemsNico, { rare: 'N' })
      },

      itemsNico2 () {
        return _.where(this.itemsFiltered, { collection: 'ニコチケ二択目' })
      },

      itemsNico2PR () {
        return _.where(this.itemsNico2, { rare: 'PR' })
      },

      itemsNico2SR () {
        return _.where(this.itemsNico2, { rare: 'SR' })
      },

      itemsNico2R () {
        return _.where(this.itemsNico2, { rare: 'R' })
      },

      itemsNico2N () {
        return _.where(this.itemsNico2, { rare: 'N' })
      },

      itemsSpKiraNico () {
        return _.where(this.itemsFiltered, { collection: 'SpKiraNico' })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1,8,10,11,13,14]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="JR ◆◆◆◆" color="#44cd1f" :items="itemsJR10" />
    </template>

    <template #col2>
      <ItemList title="ジュエルコレクション" color="#44cd1f" :items="itemsJewelCollection" />
      <ItemList title="RR ◆◆◆◆" color="#edd50f" :items="itemsRR" />
      <ItemList title="HR ★★★★" color="#ff5d91" :items="itemsHR" />
    </template>

    <template #col3>
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
      <ItemList title="SR モーリー限定 ★★" color="#55b272" :items="itemsMolly" />
    </template>

    <template #col4>
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
    </template>

    <template #col5>
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
      <ItemList title="パシャッとアイテム" color="#c598ff" :items="itemsPasha" />
    </template>

    <template #col6>
      <ItemList title="プレゼントボックス" color="#c598ff" :items="itemsPBox" />
      <ItemList title="ジュエルパクト" color="#c598ff" :items="itemsJewelPact" />
      <ItemList title="バレンタインチャンネル" color="#a1c0fa" :items="itemsValentineChannel" />
    </template>

    <template #col7>
      <ItemList title="デザインパレット自作" color="#c598ff" :items="itemsDesignPalette" />
      <ItemList title="ブランドランク" color="#c598ff" :items="itemsBrandRank" />
    </template>

    <template #col8>
      <ItemList title="スペシャルキラニコチケ|JR ◆◆◆◆" color="#44cd1f" :items="itemsSpKiraNico" />
      <ItemList title="ニコチケ PR ★★★" color="#ffa1bc" :items="itemsNicoPR" />
      <ItemList title="ニコチケ SR ★★" color="#00c7da" :items="itemsNicoSR" />
    </template>

    <template #col9>
      <ItemList title="ニコチケ R ★" color="#feab0d" :items="itemsNicoR" />
    </template>

    <template #col10>
      <ItemList title="ニコチケ二択目 PR ★★★" color="#ffa1bc" :items="itemsNico2PR" />
      <ItemList title="ニコチケ二択目 SR ★★" color="#00c7da" :items="itemsNico2SR | first(5 * 4)" />
    </template>

    <template #col11>
      <ItemList title="ニコチケ二択目 SR ★★" color="#00c7da" :items="itemsNico2SR | rest(5 * 4)" :isOrphan="true" />
    </template>

    <template #col12>
      <ItemList title="ニコチケ二択目 R ★" color="#feab0d" :items="itemsNico2R | first(9 * 4)" />
    </template>

    <template #col13>
      <ItemList title="ニコチケ二択目 R ★" color="#feab0d" :items="itemsNico2R | rest(9 * 4)" :isOrphan="true" />
    </template>

    <template #col14>
      <ItemList title="ニコチケ二択目 N" color="#f6c3b2" :items="itemsNico2N" />
      <Status :date="date" :items="items" :showKira="true" :showNico="true" :showHR="true" />
    </template>

    <template #col15>
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // コレクショングループ間の間隔 (RR)
  .Page ::v-deep .Page__col:nth-child(2) .ItemList:nth-child(2) {
    .Item:nth-child(9),
    .Item:nth-child(10),
    .Item:nth-child(11),
    .Item:nth-child(12) {
      margin-top: $size-unit * 8;
    }
  }

  // コレクショングループ間の間隔 (HR)
  .Page ::v-deep .Page__col:nth-child(2) .ItemList:nth-child(3) {
    .Item:nth-child(13),
    .Item:nth-child(14),
    .Item:nth-child(15),
    .Item:nth-child(16) {
      margin-top: $size-unit * 8;
    }
  }

  // コレクショングループ間の間隔 (PR)
  .Page ::v-deep .Page__col:nth-child(3) .ItemList:nth-child(1) {
    .Item:nth-child(13),
    .Item:nth-child(14),
    .Item:nth-child(15),
    .Item:nth-child(16) {
      margin-top: $size-unit * 8;
    }
  }

  // コレクショングループ間の間隔 (SR)
  .Page ::v-deep .Page__col:nth-child(4) .ItemList:nth-child(1) {
    .Item:nth-child(21),
    .Item:nth-child(22),
    .Item:nth-child(23),
    .Item:nth-child(24) {
      margin-top: $size-unit * 8;
    }
  }

  // コレクショングループ間の間隔 (プレゼントボックス)
  .Page ::v-deep .Page__col:nth-child(6) .ItemList:nth-child(1) {
    .Item:nth-child(13),
    .Item:nth-child(14),
    .Item:nth-child(15),
    .Item:nth-child(16),
    .Item:nth-child(25),
    .Item:nth-child(26),
    .Item:nth-child(27),
    .Item:nth-child(28) {
      margin-top: $size-unit * 8;
    }
  }

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    right: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 20;
  //   }
  // }
</style>
